<template>
  <b-container>
    {{ result.length }}
    <b-table :items="result" />
  </b-container>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin'

export default {
    name: 'OpenstaandView',
    mixins: [serviceMixin],
    data() {
        return {
            result: []
        }
    },
    mounted() {
        this.getOpenstaand()
    },
    methods: {
        getOpenstaand() {
            var vm = this;
            this.get('/status/unclosed').then((response) => 
            vm.result = response.data.openstaand
            ).catch((error) => console.log(error))
        }
    }
}
</script>